import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'date',
    headerName: 'תאריך',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'waterCard',
    headerName: 'כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'meterNumber',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'problemStart',
    headerName: 'מועד תחילת התקלה',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
]

export default columnsConfig
